import React from 'react';
import PropTypes from 'prop-types';
import { PlayerProfilePreview } from "../../";

import "./CoachTile.scss";
import { GREEN_LIGHT } from '../../styles/shared/colors';

const CoachTile = ({ coach })=> {
  const { avatar, fullName, role, accountType, avatarBgColor, firstName, lastName } = coach;
  return (
    <div className="coach-tile">
      <PlayerProfilePreview 
        avatar={avatar} 
        hasDetails={false} 
        avatarBgColor={avatarBgColor}
        firstName={firstName}
        lastName={lastName}
      />
      <span style={{ margin: "5px 0px" }}>{fullName}</span>
      <span style={{ color: GREEN_LIGHT }}>{role || accountType}</span>
    </div>
  );
};

CoachTile.propTypes = {
  coach: PropTypes.object
};

CoachTile.defaultProps = {
  coach: {}
}

export default CoachTile;